// extracted by mini-css-extract-plugin
module.exports = {"list":"Index_list_3eQes","listInner":"Index_listInner__w7Hu","item":"Index_item_1ZXb5"};